import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'
import { Button } from "./ui/button"
import { Menu, X } from "lucide-react"
import UserDropdown from './UserDropdown'

interface SharedHeaderProps {
  sidebarOpen?: boolean
  setSidebarOpen?: (open: boolean) => void
  mobileSidebarOpen?: boolean
  setMobileSidebarOpen?: (open: boolean) => void
  title?: string
  className?: string
}

export default function SharedHeader({ 
  sidebarOpen = true, 
  setSidebarOpen, 
  mobileSidebarOpen = false, 
  setMobileSidebarOpen,
      title = "Kiemo Draugas",
  className = ""
}: SharedHeaderProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()

  const handleNavigation = (url: string) => {
    navigate(url)
    if (setMobileSidebarOpen) {
      setMobileSidebarOpen(false)
    }
  }

  return (
    <header className={`flex h-16 shrink-0 items-center justify-between border-b border-emerald-100 bg-white/80 backdrop-blur-sm px-4 shadow-sm ${className}`}>
      <div className="flex items-center gap-2">
        {setMobileSidebarOpen && (
          <Button
            variant="ghost"
            size="sm"
            className="text-emerald-700 hover:bg-emerald-50 lg:hidden"
            onClick={() => setMobileSidebarOpen(true)}
          >
            <Menu className="h-5 w-5" />
          </Button>
        )}
        {setSidebarOpen && (
          <Button
            variant="ghost"
            size="sm"
            className="text-emerald-700 hover:bg-emerald-50 hidden lg:flex"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <Menu className="h-5 w-5" />
          </Button>
        )}
        <div className="h-4 w-px bg-emerald-200" />
        <h1 className="text-lg font-semibold text-emerald-800">{title}</h1>
      </div>

      <div className="flex items-center gap-4">
        <UserDropdown user={user} />
      </div>
    </header>
  )
} 